module.exports = __webpack_public_path__ + "static/media/galway-3.f56eb254.jpg";